import { RG_TYPE } from '../../types/rg-type.js';

/** types of children shared by similar module-like parents such as module/core/tehnical space */
const ModuleLikeChildrenTypes = [RG_TYPE.Wall, RG_TYPE.Floor, RG_TYPE.Ceiling, RG_TYPE.Beam, RG_TYPE.Column];

export { ModuleLikeChildrenTypes };
//# sourceMappingURL=module-like-children-types.js.map
